import { Order } from "../../../../Types/Order";

export const postReadyStamp = async (orderId: Order['id'], token: string) => {
    const readyUrl = 'https://customer.hirsch.com/order/v1/ready'

    try {
        const response = await fetch(readyUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': btoa(`Bearer ${token}`)
            },
            body: JSON.stringify({ order: orderId })
        })
        const json = await response.json()

        return json;
    } catch(err: any) {
        return err;
    }
};